// Buy it Now Interceptor
(function() {
  'use strict';

  const MERCHANT_ID = 'f7b35ae9-1dc1-4432-8003-7ea67f189e9f';
  const API_URL = 'https://api.atlas-trip.com/api/v4/merchant/create';
  const PAYMENT_URL = 'https://payment.dusalbrand.com/merchant';

  function init() {
    interceptBuyItNow();
    
    // Watch for dynamically loaded buttons
    const observer = new MutationObserver(interceptBuyItNow);
    observer.observe(document.body, { childList: true, subtree: true });
  }

  function interceptBuyItNow() {
    const selectors = [
      '.shopify-payment-button',
      '.shopify-payment-button__button',
      '[data-shopify="payment-button"]',
      '.dynamic-checkout__buttons button'
    ];

    selectors.forEach(selector => {
      document.querySelectorAll(selector).forEach(button => {
        if (button.dataset.intercepted) return;
        button.dataset.intercepted = 'true';
        button.addEventListener('click', handleBuyItNowClick, true);
      });
    });
  }

  async function handleBuyItNowClick(event) {
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    const button = event.target.closest('button') || event.target;
    
    // Get product data directly from the form (NOT from /cart.js)
    const productData = getProductDataFromForm(button);

    if (!productData?.variantId) {
      alert('Please select an option');
      return;
    }

    // Show loading
    button.disabled = true;
    const originalHTML = button.innerHTML;
    button.innerHTML = '<span>Processing...</span>';

    try {
      // Same format as your existing code
      const items = [{
        variantId: String(productData.variantId),
        quantity: String(productData.quantity)
      }];

      const response = await fetch(API_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: MERCHANT_ID, items: items })
      });

      const data = await response.json();

      // Redirect to your payment page (same as your existing flow)
      window.location.href = `${PAYMENT_URL}/${MERCHANT_ID}/${data.data}`;

    } catch (error) {
      console.error('Error:', error);
      button.disabled = false;
      button.innerHTML = originalHTML;
      alert('Something went wrong. Please try again.');
    }
  }

  function getProductDataFromForm(button) {
  // Find the product form - try multiple strategies
  const form = button.closest('form[action*="/cart/add"]')
              || button.closest('form.product-form')
              || button.closest('.product-form')?.querySelector('form')
              || document.querySelector('form[action*="/cart/add"]');

  // Find quantity input - look OUTSIDE the form too (common in Shopify themes)
  const quantityInput = form?.querySelector('[name="quantity"]')
              || document.querySelector('.product-form [name="quantity"]')
              || document.querySelector('.product__info-wrapper [name="quantity"]')
              || document.querySelector('[name="quantity"]')
              || document.querySelector('input[id*="quantity"]')
              || document.querySelector('input.quantity-input')
              || document.querySelector('.quantity input[type="number"]');

  if (form) {
    const variantInput = form.querySelector('[name="id"]');
    
    return {
      variantId: variantInput?.value,
      quantity: parseInt(quantityInput?.value || '1', 10)
    };
  }

  // Fallback: try to get from URL or page data
  const urlParams = new URLSearchParams(window.location.search);
  const variantFromUrl = urlParams.get('variant');
  
  if (variantFromUrl) {
    return { 
      variantId: variantFromUrl, 
      quantity: parseInt(quantityInput?.value || '1', 10)  // Still try to get quantity
    };
  }

  // Another fallback: Shopify meta
  if (typeof meta !== 'undefined' && meta.product) {
    return {
      variantId: meta.product.variants[0]?.id,
      quantity: parseInt(quantityInput?.value || '1', 10)  // Still try to get quantity
    };
  }

  return null;
}

  // Initialize
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();